const mediaQuery = window.matchMedia("(min-width: 768px)");

function handleScreenChange(e) {
    if (e.matches) {
        return
    } else {
        const menuIcon = document.getElementById("menu-mobile-icon");
        const mobileMenu = document.getElementById("mobile-menu");
        const closeMenu = document.getElementById("close-menu");

        function openMenu() {
            document.body.classList.add('overflow-hidden');
            mobileMenu.classList.remove("-translate-x-full");
            closeMenu.classList.remove("scale-0", "opacity-0");
            closeMenu.classList.add("scale-100", "opacity-100");
        }

        function closeMenuFunc() {
            document.body.classList.remove('overflow-hidden');
            mobileMenu.classList.add("-translate-x-full");
            closeMenu.classList.remove("scale-100", "opacity-100");
            closeMenu.classList.add("scale-0", "opacity-0");
        }

        if (menuIcon && mobileMenu && closeMenu) {
            menuIcon.addEventListener("click", openMenu);
            closeMenu.addEventListener("click", closeMenuFunc);

            document.addEventListener("click", function (event) {
                const isMenuOpen = !mobileMenu.classList.contains("-translate-x-full");
                if (isMenuOpen && !mobileMenu.contains(event.target) && !menuIcon.contains(event.target)) {
                    closeMenuFunc();
                }            
            });
        }
    }
}

mediaQuery.addEventListener("change", handleScreenChange);
handleScreenChange(mediaQuery);

function toggleMenu(button) {
    const submenu = button.nextElementSibling;
    const arrow = button.querySelector('svg');

    document.querySelectorAll('.submenu').forEach((menu) => {
        const btn = menu.previousElementSibling;

        if (menu !== submenu) {
            menu.classList.add('hidden');
            btn.classList.remove('bg-b2c-gray-light', 'text-b2c-primary');

            const icon = btn.querySelector('svg');
            if (icon) icon.style.transform = 'rotate(0deg)';
        }
    });

    submenu.classList.toggle('hidden');

    if (submenu.classList.contains('hidden')) {
        button.classList.remove('bg-b2c-gray-light');
        button.classList.remove('text-b2c-primary');
    } else {
        button.classList.add('bg-b2c-gray-light');
        button.classList.add('text-b2c-primary');
    }

    if (arrow) {
        arrow.style.transform = submenu.classList.contains('hidden') ? 'rotate(0deg)' : 'rotate(180deg)';
    }
}